import { InvoiceDTO, Permission } from 'core/api';
import { Command } from 'pos/common';
import { Preconditions } from 'core/infrastructure-next';
import * as InvoiceStore from './InvoiceStore';
import { printDocument } from 'pos/modules/helpers/document-printing';
import { PrintFacade } from 'pos/facades';

declare global {
	interface CommandType {
		printInvoice: (invoice: InvoiceDTO) => Promise<Result>
	}
}

Command.register('printInvoice', Preconditions.ensure(Permission.Ticket_PrintCopy), async (invoice: InvoiceDTO): Promise<Result> => {
	const options = await PrintFacade.getPrintOptions(invoice.Type);
	return printDocument({
		getOptions: () => options,
		print: params => InvoiceStore.print(invoice.Id, params)
	});
});
